import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Heading from '../../components/heading';
import withFetch from '../../hoc/withFetch';
import { REACT_APP_API_BASE } from '../../config';
import { Tools, ReportSheet } from '../../components/report';
import './styles.scss';

class DataEntry extends Component {

    state = {
        isLoading: true,
        isUploading: false,
        isUploadError: false,
        isSaving: false,
        isSaved: false,
        branch: null,
        periods: [],
        isWarning: false,
        fileName: ''
    };

    sumX(x, sumFrom, sumTo) {
        let val = 0;
        let hasValue = false;
        this.state.table.rows[x].columns.forEach((col, i) => {
            if (col.value !== null && i >= sumFrom && i < sumTo) {
                hasValue = true;
                val = parseFloat((val + (col.value*1)).toFixed(10));
            }
        });

        return !hasValue ? '' : val.toLocaleString('sv');
    }

    sumColumn(y) {
        let val = 0;
        let hasValue = false;
        this.state.table.rows.forEach(row => {
           let colVal = row.columns[y].value;
           if (colVal !== null) {
                hasValue = true;
                if (colVal.toString().endsWith('.') || colVal.toString().endsWith(',')) {
                    colVal = colVal.toString().replace(',', '').replace('.', '');
                } 
                if (colVal.toString().endsWith('-')) {
                    colVal = 0;
                }
                val = parseFloat((val + (colVal*1)).toFixed(10));
           }
        });
       
        return !hasValue ? '' : val.toLocaleString('sv');
    }

    sumCategory(y, sumId) {
        let val = 0;
        let hasValue = false;
        const filteredRows = this.state.table.rows.filter(r => r.category && r.category.id === sumId);
        filteredRows.forEach((row, i) => {
            let colVal = row.columns[y].value;
            if (colVal !== null) {
                hasValue = true;
                if (colVal.toString().endsWith('.') || colVal.toString().endsWith(',')) {
                    colVal = colVal.toString().replace(',', '').replace('.', '');
                } 
                if (colVal.toString().endsWith('-')) {
                    colVal = 0;
                }
                val = parseFloat((val + (colVal*1)).toFixed(10));
            }
        });
        return !hasValue ? '' : val.toLocaleString('sv');
        
    }

    sumMerchandise(y, sumId) {
        let val = 0;
        let hasValue = false;
        const filteredRows = this.state.table.rows.filter(r => r.merchandiseGroup && r.merchandiseGroup.id === sumId);
        filteredRows.forEach((row, i) => {
            let colVal = row.columns[y].value;
            if (colVal !== null) {
                hasValue = true;
                if (colVal.toString().endsWith('.') || colVal.toString().endsWith(',')) {
                    colVal = colVal.toString().replace(',', '').replace('.', '');
                } 
                if (colVal.toString().endsWith('-')) {
                    colVal = 0;
                }
                val = parseFloat((val + (colVal*1)).toFixed(10));
            }
        });
        return !hasValue ? '' : val.toLocaleString('sv');
    }

    formatValue(val) {
        if (val === null) {
            return '';
        }

        let valueFormatted = val.toString();
        valueFormatted = valueFormatted.replace(',', '.').replace('−', '-');
        valueFormatted = valueFormatted.replace(/^(-)|[^0-9.,]+/g, '$1');
        
        if (valueFormatted.includes('.')) {
            
            const values = valueFormatted.split('.');
            return `${parseFloat(values[0]).toLocaleString('sv')},${values[1]}`;
        } else {
            if (valueFormatted === '') {
                return valueFormatted;
            }

            if (isNaN(parseFloat(valueFormatted))) {
                return val;
            }

            return parseFloat(valueFormatted).toLocaleString('sv');
        }
    }

    updateData(e, item) {
        let val = e.currentTarget.value.toString();
        val = val.replace(',', '.').replace('−', '-');
        val = val.replace(/^(-)|[^0-9.,]+/g, '$1');
        const offset = this.formatValue(e.currentTarget.value).length - e.currentTarget.value.length;
        const caret = e.target.selectionStart;
        const element = e.target;
        window.requestAnimationFrame(() => {
            element.selectionStart = caret+offset;
            element.selectionEnd = caret+offset;
        });
        
        const updateModel = { ...this.state };
        const { x, y } = item;
        if (isNaN(val*1) ) {
            if (val === '-') {
                updateModel.table.rows[x].columns[y] = { ...updateModel.table.rows[x].columns[y], value: val };
                this.setState(updateModel);
            }

            return;
        }
        updateModel.table.rows[x].columns[y] = { ...updateModel.table.rows[x].columns[y], value: val };
        this.setState(updateModel);
    }

    resetTable() {
        const updateModel = {...this.state.table};
        updateModel.rows.forEach(row => {
            row.columns.forEach(col => {
                if (col.columnValueType=== 'Value') {
                    col.value = null;
                }
            });
        });

        this.setState({
            table: updateModel
        });
    }

    zeroTable() {
        const updateModel = {...this.state.table};
        updateModel.rows.forEach(row => {
            row.columns.forEach(col => {
                if (col.columnValueType=== 'Value') {
                    col.value = 0;
                }
            });
        });

        this.setState({
            table: updateModel
        });
    }

    async save() {
        this.setState({
            isSaving: true
        });

        const { isLoading, isSaved, periods, isWarning, isUploading, isUploadError,  ...saveTable } = this.state;
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
      
        const rawResponse = await fetch(`${REACT_APP_API_BASE}/reporting`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(saveTable)
        });

        if (rawResponse.ok) {
            const content = await rawResponse.json();
            setTimeout(() => {
                this.setState({
                    isSaving: false,
                    isSaved: true,
                    ...content
                });
            }, 1500);

            setTimeout(() => {
                this.setState({
                    isSaved: false,
                    isUploadError: false,
                    fileName: ''
                });
            }, 6000)
        }        
    }

    async componentDidMount() {
        const { match } = this.props;
        const res = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/branches/${match.params.branchId}/periods`);
        if (!res.ok) {
            //handle 404
        }

        const periods = await res.json();

        let registerSheet = {};
        if (match.params.periodId) {
            const resRegisterSheet = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/companies/${match.params.companyId}/branches/${match.params.branchId}/periods/${match.params.periodId}`);

            registerSheet = await resRegisterSheet.json();
        }

        this.setState({
            isLoading: false,
            periods,
            ...registerSheet
        });
        
    }

    async componentDidUpdate(nextProps) {
        const { match } = this.props;

        if (match.params.periodId !== nextProps.match.params.periodId) {
            this.setState({
                isLoading: true
            });
            const resRegisterSheet = await this.props.fetch(`${REACT_APP_API_BASE}/reporting/companies/${match.params.companyId}/branches/${match.params.branchId}/periods/${match.params.periodId}`);

            const registerSheet = await resRegisterSheet.json();
            this.setState({
                isLoading: false,
                isWarning: false,
                isUploadError: false,
                fileName:'',
                ...registerSheet
            });
        }
    }

    handleChange(e) {
        const { history, match } = this.props;
        history.push(`/company/${match.params.companyId}/branch/${match.params.branchId}/period/${e.target.value}`);
    }

    hasWarnings(isWarning) {
        if (isWarning && !this.state.isWarning && !this.state.isLoading) {
            this.setState({
                isWarning: true
            });
        }
    }

    async uploadFile(e) {
        this.setState({
            isUploading: true,
            fileName: e.target.files[0].name
        });
        const data = new FormData() 
        data.append('file', e.target.files[0]);
        data.append('companyid', this.state.company.id);
        data.append('branchid', this.state.branch.id);
        data.append('periodid', this.state.period.id);

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
      
        const rawResponse = await fetch(`${REACT_APP_API_BASE}/reporting/fromfile`, {
            method: 'POST',
            headers: headers,
            body: data
        });

        if (!rawResponse.ok) {
            //Show error message
            this.setState({
                isUploading: false,
                isUploadError: true
            });
            return;
        }

        const registerSheet = await rawResponse.json();
        this.setState({
            isUploading: false,
            isUploadError: false,
            ...registerSheet
        });
    }

    render() {
        return (
            <section className="report-data-entry">
                <Heading heading="Inrapportering" modifiers={{
                    'page-header--stack':  true,
                    'page-header--sticky':  true,
                }}>
                    <Tools {...this.state} onChange={(e) => this.handleChange(e)} />
                </Heading>
                {this.state.table &&
                    <ReportSheet data={this.state.table} 
                                 additionalInfo={this.state.branch && this.state.branch.additionalInfo}
                                 isLoading={this.state.isLoading} 
                                 isSaved={this.state.isSaved} 
                                 isWarning={this.state.isWarning}
                                 updateData={((e, item) => this.updateData(e, item))} 
                                 formatValue={value => this.formatValue(value)}
                                 sumX={(x, sumFrom, sumTo) => this.sumX(x, sumFrom, sumTo)} 
                                 sumCategory={(y, id) => this.sumCategory(y, id)} 
                                 sumMerchandise={(y, id) => this.sumMerchandise(y, id)} 
                                 sumColumn={(y) => this.sumColumn(y)} 
                                 resetTable={() => this.resetTable()} 
                                 zeroTable={() => this.zeroTable()} 
                                 save={() => this.save()} 
                                 companyUrl={`/company`}
                                 hasWarnings={(isWarning) => this.hasWarnings(isWarning)}  
                                 uploadFile={(e) => this.uploadFile(e)} 
                                 isUploading={this.state.isUploading} 
                                 isUploadError={this.state.isUploadError} 
                                 fileName={this.state.fileName}
                                 isSaving={this.state.isSaving} />
                }
            </section>
        );
    }
};

export default withRouter(withFetch(DataEntry));